module.exports = __webpack_public_path__ + "media/customizations/creekhavenlife/logo-bd1e6c56a9c8a670b584c6d23d87aedf.png";